import { useSelector } from 'react-redux';
import { _ } from '/@/locale';
import { getAppInstance, getCornRecommendationEnabled } from '/@/store/session/selectors';

const useOverlayConfig = () => {
    const actualAppInstance = useSelector((state) => getAppInstance(state));
    const enableSoyRecommendation = false; // useSelector((state) => getSoyRecommendationEnabled(state, actualAppInstance));
    const enableCornRecommendation = useSelector((state) => getCornRecommendationEnabled(state, actualAppInstance));
    let overlayConfig = [
        {
            label: _('Seguimiento de Maíz'),
            icon: 'cropMonitoring',
            color: 'orange',
            enable: true,
            type: 'corn',
            id: 'cropMonitoringCorn',
        },
        {
            label: _('Seguimiento de Soja'),
            icon: 'cropMonitoring',
            color: 'green',
            enable: false,
            type: 'soy',
            id: 'cropMonitoringSoy',
        },
    ];
    overlayConfig = overlayConfig.filter(
        (oc) => (oc.type === 'corn' && enableCornRecommendation) || (oc.type === 'soy' && enableSoyRecommendation)
    );
    return overlayConfig;
};

export default useOverlayConfig;
